import {
  productionLoadLabel,
  type MfgProductionLoad,
} from "@/lib/manufacturing/productionLoadsClient";
import { inputClass, mfgSecondaryBtnClass } from "@/components/manufacturing/manufacturingSurfaceClasses";

export function BuildPipelineUnitLoadAssign({
  loadId,
  openLoads,
  busy,
  onAssign,
}: {
  loadId: string | null | undefined;
  openLoads: MfgProductionLoad[];
  busy: boolean;
  onAssign: (loadId: string | null) => void;
}) {
  const current = openLoads.find((l) => l.id === loadId) ?? null;
  const value = loadId ?? "";

  return (
    <section>
      <h3 className="mb-2 text-xs font-semibold uppercase tracking-wide text-gray-500">
        Production load
      </h3>
      {current ? (
        <p className="mb-2 text-xs text-gray-600 dark:text-zinc-400">{productionLoadLabel(current)}</p>
      ) : loadId ? (
        <p className="mb-2 text-xs text-gray-500">Assigned (load not in open list).</p>
      ) : (
        <p className="mb-2 text-xs text-gray-500">Not assigned. Ops assigns a letter before sending the load to the plant.</p>
      )}
      <div className="flex gap-2">
        <select
          className={`${inputClass} min-w-0 flex-1`}
          value={value}
          disabled={busy || (openLoads.length === 0 && !loadId)}
          onChange={(e) => onAssign(e.target.value || null)}
        >
          <option value="">Unassigned</option>
          {openLoads.map((load) => (
            <option key={load.id} value={load.id}>
              {productionLoadLabel(load)}
            </option>
          ))}
        </select>
        {loadId ? (
          <button
            type="button"
            className={mfgSecondaryBtnClass}
            disabled={busy}
            onClick={() => onAssign(null)}
          >
            Clear
          </button>
        ) : null}
      </div>
    </section>
  );
}
